import { List } from 'immutable';
import { hasValue } from '@famly/stat_ts-utils_has-value';
import { exhaustiveCheck } from '@famly/stat_ts-utils_exhaustive-check';
export { 
/**
 * @deprecated import `hasValue` directly from '@famly/stat_ts-utils_has-value
 */
hasValue, 
/**
 * @deprecated import `exhaustiveCheck` directly from '@famly/stat_ts-utils_exhaustive-check
 */
exhaustiveCheck, };
export function nameofFactory() {
    return (name) => name;
}
class Comp {
    constructor(apply) {
        this.apply = apply;
    }
    with(f) {
        return new Comp(x => this.apply(f(x)));
    }
}
export function compose(f) {
    return new Comp(f);
}
export function mapAndReduce(input, extract, reduce, initialValue) {
    return List(input).map(extract).reduce(reduce, initialValue);
}
/**
 * Use this as a type-safe alternative to access properties on an object through bracket notation
 * @example
 * getProperty({foo: 'bar', ['wiz-biz']: 123}, 'data-wee') // Typescript error 🙅‍♂️
 * getProperty({foo: 'bar', ['wiz-biz']: 123}, 'wiz-biz') // Typescript is happy 🤠
 */
export const getProperty = (o, propertyName) => o[propertyName];
/**
 * Use this to extract a subsection of an object while keeping any union structure intact
 * @example
 * type Foo = { bar: 'abc' } & ({ kind: 'a', variant: string } | { kind: 'b', variant: number });
 * getProperty(foo: Foo, 'kind', 'variant'): { kind: 'a', variant: string } | { kind: 'b', variant: number }
 */
export const getProperties = (o, ...propertyNames) => {
    return propertyNames.reduce((object, name) => {
        return {
            ...object,
            [name]: o[name],
        };
    }, {});
};
export const identity = (item) => item;
